import { Observable } from 'rxjs'
import CacheAPI from '../api.cache.js'
import axios from 'axios'
import { store } from '../../store/store.js'
import Vue from 'vue'

require('es6-promise').polyfill()

const cacheAPI = CacheAPI(true, 6000, {
  '/Token': true,
  '/Ticket/GetOpenTicketsAsync': true,
  '/Ticket/InsertTicket': true,
  '/Ticket/DeleteTicket': true,
  '/Time/GetSecondsToStart': true,
  '/Ticket/GetTicketHistoryAsync': true,
  '/Balance/GetBalance': true
})

const api = (function () {
  let VGameName = 'VFootball'
  axios.interceptors.request.use(function (config) {
    if (store) {
      let url = store.getUrlByGameName(VGameName)
      if (config.url.indexOf(url) >= 0) {
        let token = store.getTokenByGameName(VGameName)
        if (token) {
          config.headers.Authorization = `Bearer ${token}`
        }
      }
    }
    return config
  }, function (err) {
    return Promise.reject(err)
  })

  return {
    getGameName () {
      return VGameName
    },
    buildUrl (url) {
      return store.getUrlByGameName(VGameName) + url
    },
    getPostRequest (url, params) {
      return Observable.create((observer) => {
        if (cacheAPI.isUrlExcluded(url) || cacheAPI.isExpired(url)) {
          axios.post(this.buildUrl(url), params).then(response => {
            if (!cacheAPI.isUrlExcluded(url)) {
              cacheAPI.setCache(url, params, response.data)
            }
            observer.next(response.data)
            observer.complete()
          }, response => {
            observer.error(response)
            observer.complete()
          })
        } else {
          let response = cacheAPI.getCache(url)
          observer.next(response.data)
          observer.complete()
        }
      })
    },
    getSecondsToStart () {
      return this.getPostRequest('/Time/GetSecondsToStart')
    },
    getConfig () {
      return this.getPostRequest('/Config/GetConfig')
    },
    getGetOpenTickets () {
      return this.getPostRequest('/Ticket/GetOpenTicketsAsync', {
        'currentOperator': store.getUsername(),
        'gameInProgress': store.isGameInProgress()
      })
    },
    getBetHistoryTickets (dateFrom = null, dateTo = null) {
      return Observable.create((observer) => {
        dateFrom = dateFrom.setHours(0, 0, 0, 0)
        dateFrom = new Date(dateFrom)
        dateTo = dateTo.setHours(23, 59, 59, 999)
        dateTo = new Date(dateTo)
        return this.getPostRequest('/Ticket/GetTicketHistoryAsync', {
          'currentOperator': store.getUsername(),
          'gameInProgress': store.isGameInProgress(),
          'option': 2,
          'dateFrom': dateFrom,
          'dateTo': dateTo
        }).subscribe(response => {
          let tickets = []
          if (response.TicketList) {
            response.TicketList.forEach(element => {
              Vue.set(element, 'isOpen', false)
            })
            tickets = response.TicketList.filter(item => item.Status !== 2)
          }
          observer.next(tickets)
          observer.complete()
        }, error => {
          observer.error(error)
          observer.complete()
        })
      })
    },
    getVideoList () {
      return this.getPostRequest('/Videolist/GetVideolistAll')
    },
    getPlayList (match) {
      return Observable.create((observer) => {
        let matchNo = 0
        if (match && match.Matches && match.Matches[0]) {
          matchNo = match.Matches[0].MatchNo
        }
        this.getPostRequest('/Videolist/GetVideolist', { MatchNo: matchNo }).subscribe(data => {
          var result = data
          result.AwayTeam = match.Matches[0].AwayTeam
          result.AwayTeamLogo = match.Matches[0].AwayTeamLogo
          result.awayTeamShort = match.Matches[0].AwayTeamShort
          result.HomeTeam = match.Matches[0].HomeTeam
          result.HomeTeamLogo = match.Matches[0].HomeTeamLogo
          result.HomeTeamShort = match.Matches[0].HomeTeamShort
          if (result.FirstHalf && result.SecondHalf) {
            result.videoList = result.FirstHalf.concat(result.SecondHalf)
          }
          observer.next(result)
          observer.complete()
        }, response => {
          observer.error(response)
          observer.complete()
        })
      })
    },
    getJackpot () {
      return Observable.create((observer) => {
        this.getPostRequest('/Jackpot/GetJackpot').subscribe(response => {
          let jackpots = []
          let championJackpot = []
          let stadiumJackpot = []
          let winningJackpotsChampion = []
          let winningJackpotsStadium = []

          if (response.Jackpots && response.Jackpots.length > 0) {
            jackpots = response.Jackpots
            Object.keys(response.Jackpots).forEach((key) => {
              for (const [prop, value] of Object.entries(response.Jackpots[key])) {
                if (prop === 'Type') {
                  if (value.includes('Stadium JP')) {
                    stadiumJackpot = [...stadiumJackpot, response.Jackpots[key]]
                  } else if (value.includes('Champion JP')) {
                    championJackpot = [...championJackpot, response.Jackpots[key]]
                  }
                }
              }
            })
          }

          if (response.ChampionsPastWinningTickets && response.ChampionsPastWinningTickets.length > 0) {
            winningJackpotsChampion = response.ChampionsPastWinningTickets
          }

          while (winningJackpotsChampion.length < 3) {
            winningJackpotsChampion.push({ Barcode: '-' })
          }

          if (response.StadiumPastWinningTickets && response.StadiumPastWinningTickets.length > 0) {
            winningJackpotsStadium = response.StadiumPastWinningTickets
          }

          while (winningJackpotsStadium.length < 3) {
            winningJackpotsStadium.push({ Barcode: '-' })
          }
          observer.next({
            'jackpots': jackpots,
            'championJackpot': championJackpot,
            'stadiumJackpot': stadiumJackpot,
            'winningJackpotsChampion': winningJackpotsChampion,
            'winningJackpotsStadium': winningJackpotsStadium
          })
          observer.complete()
        }, error => {
          observer.error(error)
          observer.complete()
        })
      })
    },
    getWinningJackpot () {
      return this.getPostRequest('/Jackpot/GetWinningJackpot')
    },
    getMatches (p) {
      return this.getPostRequest('/Match/GetPanelMatches', { panel: p })
    },
    getResults () {
      return this.getPostRequest('/Match/GetResults')
    },
    getBalance () {
      this.getPostRequest('/Balance/GetBalance').subscribe(data => {
        store.setBalance(data.BalanceInCents / 100)
        store.setCurrency(data.Currency)
      })
    },
    deleteTicket (ticketID) {
      return this.getPostRequest('/Ticket/DeleteTicket', { ticketCheckID: ticketID })
    },
    checkTicketAsync (ticketID) {
      return this.getPostRequest('/Ticket/CheckTicketAsync', {
        ticketCheckID: ticketID,
        currentOperator: store.getOperator()
      })
    },
    insertTicket (payIn, matches) {
      return this.getPostRequest('/Ticket/InsertTicket', {
        'PayIn': payIn * 100,
        'currentOperator': store.getOperator(),
        'Matches': matches
      })
    }
  }
})()

export default api
